import React from "react";
import styles from './CustomFileInput.module.css';
import CustomText from "../customText/CustomText";
import CustomButton from "../customButton/CustomButton";
import { useTranslation } from "react-i18next";
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import CustomIcon from "../customIcon/CustomIcon";

type CustomFileInputType = {
    id: string,
    label: string,
    fileName: string,
    file: File | null,
    setValue: (value: File | null) => void,
    removeFile: Function,
    accept?: string
}

const CustomFileInput = (props: CustomFileInputType) => {

    const {t} = useTranslation();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0)
            props.setValue(e.target.files[0])
    }

    return (
        <div id={props.id} className={styles.container}>
            <CustomButton className={styles.fileBtn} component="label" startIcon={<AttachFileRoundedIcon />}>
                { t('general.add_file') }
                <input type='file' onChange={e => handleChange(e)} accept={props.accept} hidden/>
            </CustomButton>

            { props.fileName &&
                    <div className={styles.containerFile}>
                        <CustomText>{ `${t('general.selected_file')} : ${props.fileName}` }</CustomText>
                        <div className={styles.deleteIcon}>
                            <CustomIcon label={t('general.delete')} icon="delete" onClick={props.removeFile} />
                        </div>
                    </div>
            }

            { !props.fileName &&
                <CustomText>{ t('general.no_file') }</CustomText>
            }
        </div>
    );
}

export default CustomFileInput;